<script>
	export let fontSize = 'text-base tracking-wide'
	export let fontWeight = 'font-semibold'
	export let color = 'text-primary-500'
	export let margin = 'my-2'
</script>

<div class="{fontSize} {fontWeight} {margin} {color}">
	<slot />
</div>
